import { render, staticRenderFns } from "./SendOptInEmailSuccessModal.vue?vue&type=template&id=5830a149&scoped=true"
import script from "./SendOptInEmailSuccessModal.vue?vue&type=script&lang=js"
export * from "./SendOptInEmailSuccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5830a149",
  null
  
)

export default component.exports